import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
	UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || "eu-west-2_onPtfi36A",
	ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || "6oio4o4dao9rb6nvep5tmncdt3",
};

export default new CognitoUserPool(poolData);
